(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[452],{

/***/ 61382:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ tag; }
});

// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(56666);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(7896);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/slicedToArray.js + 1 modules
var slicedToArray = __webpack_require__(76854);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/classnames/index.js
var classnames = __webpack_require__(72779);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ../../node_modules/rc-util/es/omit.js
var omit = __webpack_require__(94899);
// EXTERNAL MODULE: ../../node_modules/@ant-design/icons/es/icons/CloseOutlined.js + 1 modules
var CloseOutlined = __webpack_require__(65393);
// EXTERNAL MODULE: ../../node_modules/antd/es/config-provider/context.js + 1 modules
var context = __webpack_require__(75848);
;// CONCATENATED MODULE: ../../node_modules/antd/es/tag/CheckableTag.js



var __rest = undefined && undefined.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};





var CheckableTag = function CheckableTag(_a) {
  var _classNames;

  var customizePrefixCls = _a.prefixCls,
      className = _a.className,
      checked = _a.checked,
      onChange = _a.onChange,
      onClick = _a.onClick,
      restProps = __rest(_a, ["prefixCls", "className", "checked", "onChange", "onClick"]);

  var _React$useContext = react.useContext(context/* ConfigContext */.E_),
      getPrefixCls = _React$useContext.getPrefixCls;

  var handleClick = function handleClick(e) {
    onChange === null || onChange === void 0 ? void 0 : onChange(!checked);
    onClick === null || onClick === void 0 ? void 0 : onClick(e);
  };

  var prefixCls = getPrefixCls('tag', customizePrefixCls);
  var cls = classnames_default()(prefixCls, (_classNames = {}, (0,defineProperty/* default */.Z)(_classNames, "".concat(prefixCls, "-checkable"), true), (0,defineProperty/* default */.Z)(_classNames, "".concat(prefixCls, "-checkable-checked"), checked), _classNames), className);
  return /*#__PURE__*/react.createElement("span", (0,esm_extends/* default */.Z)({}, restProps, {
    className: cls,
    onClick: handleClick
  }));
};

/* harmony default export */ var tag_CheckableTag = (CheckableTag);
// EXTERNAL MODULE: ../../node_modules/antd/es/_util/colors.js
var colors = __webpack_require__(81678);
// EXTERNAL MODULE: ../../node_modules/antd/es/_util/wave.js + 1 modules
var wave = __webpack_require__(76577);
;// CONCATENATED MODULE: ../../node_modules/antd/es/tag/index.js




var tag_rest = undefined && undefined.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};









var PresetColorRegex = new RegExp("^(".concat(colors/* PresetColorTypes.join */.Y.join('|'), ")(-inverse)?$"));
var PresetStatusColorRegex = new RegExp("^(".concat(colors/* PresetStatusColorTypes.join */.E.join('|'), ")$"));

var InternalTag = function InternalTag(_a, ref) {
  var _classNames;

  var customizePrefixCls = _a.prefixCls,
      className = _a.className,
      style = _a.style,
      children = _a.children,
      icon = _a.icon,
      color = _a.color,
      onClose = _a.onClose,
      closeIcon = _a.closeIcon,
      _a$closable = _a.closable,
      closable = _a$closable === void 0 ? false : _a$closable,
      props = tag_rest(_a, ["prefixCls", "className", "style", "children", "icon", "color", "onClose", "closeIcon", "closable"]);

  var _React$useContext = react.useContext(context/* ConfigContext */.E_),
      getPrefixCls = _React$useContext.getPrefixCls,
      direction = _React$useContext.direction;

  var _React$useState = react.useState(true),
      _React$useState2 = (0,slicedToArray/* default */.Z)(_React$useState, 2),
      visible = _React$useState2[0],
      setVisible = _React$useState2[1];

  react.useEffect(function () {
    if ('visible' in props) {
      setVisible(props.visible);
    }
  }, [props.visible]);

  var isPresetColor = function isPresetColor() {
    if (!color) {
      return false;
    }

    return PresetColorRegex.test(color) || PresetStatusColorRegex.test(color);
  };

  var tagStyle = (0,esm_extends/* default */.Z)({
    backgroundColor: color && !isPresetColor() ? color : undefined
  }, style);

  var presetColor = isPresetColor();
  var prefixCls = getPrefixCls('tag', customizePrefixCls);
  var tagClassName = classnames_default()(prefixCls, (_classNames = {}, (0,defineProperty/* default */.Z)(_classNames, "".concat(prefixCls, "-").concat(color), presetColor), (0,defineProperty/* default */.Z)(_classNames, "".concat(prefixCls, "-has-color"), color && !presetColor), (0,defineProperty/* default */.Z)(_classNames, "".concat(prefixCls, "-hidden"), !visible), (0,defineProperty/* default */.Z)(_classNames, "".concat(prefixCls, "-rtl"), direction === 'rtl'), _classNames), className);

  var handleCloseClick = function handleCloseClick(e) {
    e.stopPropagation();
    onClose === null || onClose === void 0 ? void 0 : onClose(e);

    if (e.defaultPrevented) {
      return;
    }

    if (!('visible' in props)) {
      setVisible(false);
    }
  };

  var renderCloseIcon = function renderCloseIcon() {
    if (closable) {
      return closeIcon ? /*#__PURE__*/react.createElement("span", {
        className: "".concat(prefixCls, "-close-icon"),
        onClick: handleCloseClick
      }, closeIcon) : /*#__PURE__*/react.createElement(CloseOutlined/* default */.Z, {
        className: "".concat(prefixCls, "-close-icon"),
        onClick: handleCloseClick
      });
    }

    return null;
  };

  var isNeedWave = 'onClick' in props || children && children.type === 'a';
  var tagProps = (0,omit/* default */.Z)(props, ['visible']);
  var iconNode = icon || null;
  var kids = iconNode ? /*#__PURE__*/react.createElement(react.Fragment, null, iconNode, /*#__PURE__*/react.createElement("span", null, children)) : children;
  var tagNode = /*#__PURE__*/react.createElement("span", (0,esm_extends/* default */.Z)({}, tagProps, {
    ref: ref,
    className: tagClassName,
    style: tagStyle
  }), kids, renderCloseIcon());
  return isNeedWave ? /*#__PURE__*/react.createElement(wave/* default */.Z, null, tagNode) : tagNode;
};

var Tag = /*#__PURE__*/react.forwardRef(InternalTag);
Tag.displayName = 'Tag';
Tag.CheckableTag = tag_CheckableTag;
/* harmony default export */ var tag = (Tag);

/***/ }),

/***/ 42967:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/payouts",
      function () {
        return __webpack_require__(70864);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 70864:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ payouts; }
});

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../libs/ui-components/src/lib/common/DashboardLayout/index.tsx + 6 modules
var DashboardLayout = __webpack_require__(79747);
// EXTERNAL MODULE: ../../libs/frontend-utils/src/firebase/auth/FirebaseClaims.tsx
var FirebaseClaims = __webpack_require__(93598);
// EXTERNAL MODULE: ../../node_modules/next/router.js
var next_router = __webpack_require__(5632);
// EXTERNAL MODULE: ../../libs/ui-components/src/lib/common/PageCard/index.tsx + 1 modules
var PageCard = __webpack_require__(87586);
// EXTERNAL MODULE: ../../libs/data-access/src/generated/index.tsx + 5 modules
var generated = __webpack_require__(20229);
// EXTERNAL MODULE: ../../libs/pages/src/common/hooks/useVetterDisclaimer.ts
var useVetterDisclaimer = __webpack_require__(42526);
// EXTERNAL MODULE: ../../libs/frontend-utils/src/message/index.ts
var message = __webpack_require__(7476);
// EXTERNAL MODULE: ../../libs/ui-components/src/lib/common/atoms/Warning/useWarning.ts
var useWarning = __webpack_require__(52592);
// EXTERNAL MODULE: ../../libs/ui-components/src/lib/common/atoms/Typography/styles.tsx
var styles = __webpack_require__(93430);
// EXTERNAL MODULE: ../../libs/ui-components/src/lib/common/theme.ts
var theme = __webpack_require__(32657);
// EXTERNAL MODULE: ../../node_modules/antd/es/row/index.js
var row = __webpack_require__(3306);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(92228);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 2 modules
var styled_components_browser_esm = __webpack_require__(58694);
// EXTERNAL MODULE: ../../node_modules/antd/es/tag/index.js + 1 modules
var tag = __webpack_require__(61382);
// EXTERNAL MODULE: ../../libs/ui-components/src/lib/common/atoms/FormItem/index.tsx + 3 modules
var FormItem = __webpack_require__(74606);
// EXTERNAL MODULE: ../../libs/ui-components/src/lib/common/atoms/Button/index.tsx + 1 modules
var Button = __webpack_require__(81824);
// EXTERNAL MODULE: ../../node_modules/antd/es/typography/index.js + 19 modules
var typography = __webpack_require__(8722);
;// CONCATENATED MODULE: ../../libs/pages/src/vetter-platform/Payouts/styles.ts

function _templateObject() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 48px;\n  height: 48px;\n  margin-right: 12px;\n"
    ]);
    _templateObject1 = function() {
        return data;
    };
    return data;
}
function _templateObject2() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 500px;\n  display: flex;\n  flex: 1;\n  flex-direction: column;\n  gap: 36px;\n"
    ]);
    _templateObject2 = function() {
        return data;
    };
    return data;
}
function _templateObject3() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex: 1;\n  gap: 12px;\n  flex-direction: column;\n  margin-bottom: 30px;\n\n  &:nth-child(3) {\n    margin-bottom: 18px;\n  }\n"
    ]);
    _templateObject3 = function() {
        return data;
    };
    return data;
}
function _templateObject4() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-bottom: 20px;\n"
    ]);
    _templateObject4 = function() {
        return data;
    };
    return data;
}
function _templateObject5() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        ";\n  height: max-content;\n  border: none;\n  background: ",
        ";\n  padding: 1px 8px;\n  font-weight: 600;\n  margin: 0;\n"
    ]);
    _templateObject5 = function() {
        return data;
    };
    return data;
}
function _templateObject6() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n"
    ]);
    _templateObject6 = function() {
        return data;
    };
    return data;
}
function _templateObject7() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        ";\n  display: block;\n  text-align: left;\n"
    ]);
    _templateObject7 = function() {
        return data;
    };
    return data;
}
function _templateObject8() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  text-align: center;\n  margin-top: 12px;\n"
    ]);
    _templateObject8 = function() {
        return data;
    };
    return data;
}
function _templateObject9() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin: 10px 0px;\n"
    ]);
    _templateObject9 = function() {
        return data;
    };
    return data;
}
function _templateObject10() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        ";\n  display: inline;\n  font-size: inherit;\n  height: auto;\n  padding: inherit;\n  line-height: inherit;\n  font-weight: inherit;\n\n  &.ant-btn > span {\n    color: ",
        ";\n    text-decoration: underline;\n  }\n"
    ]);
    _templateObject10 = function() {
        return data;
    };
    return data;
}




const StripeTitleBox = styled_components_browser_esm/* default.div */.ZP.div(_templateObject());
const Image = styled_components_browser_esm/* default.img */.ZP.img(_templateObject1());
const Content = styled_components_browser_esm/* default.div */.ZP.div(_templateObject2());
const Section = styled_components_browser_esm/* default.div */.ZP.div(_templateObject3());
const TitleRow = (0,styled_components_browser_esm/* default */.ZP)(row/* default */.Z)(_templateObject4());
const StatBadge = (0,styled_components_browser_esm/* default */.ZP)(tag/* default */.Z)(_templateObject5(), (param)=>{
    let { theme  } = param;
    return theme.colors.white;
}, (param)=>{
    let { theme  } = param;
    return theme.colors.green40;
});
const FullWidthFormItem = (0,styled_components_browser_esm/* default */.ZP)(FormItem/* FormItem */.x)(_templateObject6());
const DisclaimerText = (0,styled_components_browser_esm/* default */.ZP)(styles/* Text */.xv)(_templateObject7(), (param)=>{
    let { theme  } = param;
    return theme.colors.grey40;
});
const DisclaimerTypography = (0,styled_components_browser_esm/* default */.ZP)(typography/* default */.Z)(_templateObject8());
const styles_Button = (0,styled_components_browser_esm/* default */.ZP)(Button/* Button */.z)(_templateObject9());
const DisclaimerButton = (0,styled_components_browser_esm/* default */.ZP)(Button/* Button */.z)(_templateObject10(), (param)=>{
    let { theme  } = param;
    return theme.colors.grey40;
}, (param)=>{
    let { theme  } = param;
    return theme.colors.grey40;
});

;// CONCATENATED MODULE: ../../libs/pages/src/vetter-platform/Payouts/StripeAccountSettings.tsx








const StripeAccountSettings = (param)=>{
    let { userId , stripeAccountConnected , viewOnly  } = param;
    const router = (0,next_router.useRouter)();
    const warning = (0,useWarning/* useWarning */.r)();
    const [generateStripeUrl] = (0,generated/* useGenerateStripeUrlMutation */.MT1)();
    const [updateStripeAccountConnected] = (0,generated/* useSetStripeAccountConnectedMutation */.SOn)({
        update (cache) {
            cache.evict({
                fieldName: "vetterDashboard"
            });
        }
    });
    const redirectToStripe = (0,react.useCallback)(async ()=>{
        var ref, ref1, ref2;
        if (!userId) {
            return;
        }
        const isSafari = ()=>navigator.userAgent.includes("Safari");
        const windowReference = isSafari() ? window.open() : null;
        const { data  } = await generateStripeUrl({
            variables: {
                userId
            }
        });
        if ((data === null || data === void 0 ? void 0 : (ref = data.generateStripeUrl) === null || ref === void 0 ? void 0 : ref.__typename) === "ValidationError") {
            var ref3;
            message/* message.error */.y.error(data === null || data === void 0 ? void 0 : (ref3 = data.generateStripeUrl) === null || ref3 === void 0 ? void 0 : ref3.messages);
        }
        if ((data === null || data === void 0 ? void 0 : (ref1 = data.generateStripeUrl) === null || ref1 === void 0 ? void 0 : ref1.__typename) === "StripeUrl" && (data === null || data === void 0 ? void 0 : (ref2 = data.generateStripeUrl) === null || ref2 === void 0 ? void 0 : ref2.url)) {
            if (windowReference) {
                windowReference.location.href = data.generateStripeUrl.url;
                return;
            } else {
                window.open(data.generateStripeUrl.url);
            }
        }
        if (windowReference) {
            windowReference.close();
        }
    }, [
        userId,
        generateStripeUrl
    ]);
    const handleStripeResult = (0,react.useCallback)(async ()=>{
        var _query;
        const { stripe_result  } = (_query = router.query) !== null && _query !== void 0 ? _query : {};
        const openConfirmation = ()=>{
            return warning.openWarning({
                text: " Fantastic! Your profile setup is complete \uD83C\uDF89",
                cancelText: "Close",
                hideOk: true
            });
        };
        if (!userId || !stripe_result) {
            return;
        }
        if (stripe_result === "return") {
            await updateStripeAccountConnected({
                variables: {
                    userId
                }
            });
            // remove query params
            router.replace("/payouts", undefined, {
                shallow: true
            });
            openConfirmation();
        }
        if (stripe_result === "refresh") {
            await redirectToStripe();
        }
    }, [
        router,
        userId,
        updateStripeAccountConnected,
        redirectToStripe,
        warning
    ]);
    (0,react.useEffect)(()=>{
        handleStripeResult();
    }, [
        handleStripeResult
    ]);
    const tooltipMessage = viewOnly ? "Fill out and save your personal information before proceeding to Stripe account setup." : "";
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Content, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Section, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(TitleRow, {
                    justify: "space-between",
                    align: "middle",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(styles/* Title */.Dx, {
                        level: 3,
                        children: "Account"
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(row/* default */.Z, {
                    justify: "space-between",
                    align: "middle",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(StripeTitleBox, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                    src: "/images/stripe-logo-small.svg"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(styles/* Title */.Dx, {
                                    level: 4,
                                    children: "Stripe"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(StatBadge, {
                            color: stripeAccountConnected ? theme/* theme.colors.green40 */.r.colors.green40 : theme/* theme.colors.grey40 */.r.colors.grey40,
                            children: stripeAccountConnected ? "CONNECTED" : "NOT CONNECTED"
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(row/* default */.Z, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(FullWidthFormItem, {
                        shouldUpdate: true,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(styles_Button, {
                                actionType: "secondary",
                                tooltipTitle: tooltipMessage,
                                onClick: redirectToStripe,
                                disabled: viewOnly,
                                block: true,
                                children: stripeAccountConnected ? "Manage Stripe" : "Set up Stripe account"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(DisclaimerTypography, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(DisclaimerText, {
                                    type: "secondary",
                                    children: [
                                        "Keep in mind that every transfer of funds to your bank account (aka payout) takes 2 business days. You can view the list of all of your payouts and the date that you expect to receive them in your bank account in the",
                                        " ",
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(DisclaimerButton, {
                                            type: "link",
                                            disabled: viewOnly,
                                            onClick: redirectToStripe,
                                            children: "Stripe Dashboard"
                                        }),
                                        "."
                                    ]
                                })
                            })
                        ]
                    })
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ../../libs/pages/src/vetter-platform/Payouts/index.tsx







const PayoutsPage = (param)=>{
    let { userId  } = param;
    var ref, ref1, ref2;
    const router = (0,next_router.useRouter)();
    const showDisclaimer = (0,useVetterDisclaimer/* useVetterDisclaimer */.h)();
    const { data , loading  } = (0,generated/* useUserQuery */.bTj)({
        variables: {
            userId
        },
        onCompleted: (param)=>{
            let { user  } = param;
            if ((user === null || user === void 0 ? void 0 : user.__typename) === "User") {
                !(user === null || user === void 0 ? void 0 : user.onboardingCompleted) && router.replace("/terms");
                showDisclaimer(user);
            }
        }
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(DashboardLayout/* DashboardLayout */.c, {
        loading: loading,
        hasStatusToggle: true,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PageCard/* PageCard */.x, {
            title: "Payouts",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StripeAccountSettings, {
                viewOnly: !(data === null || data === void 0 ? void 0 : (ref = data.user) === null || ref === void 0 ? void 0 : ref.isProfileDataProvided),
                userId: userId,
                stripeAccountConnected: data === null || data === void 0 ? void 0 : (ref1 = data.user) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.stripeUser) === null || ref2 === void 0 ? void 0 : ref2.stripeAccountConnected
            })
        })
    });
};

;// CONCATENATED MODULE: ./pages/payouts/index.tsx





const Payouts = ()=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FirebaseClaims/* FirebaseClaims */.h, {
            required: {
                id: true
            },
            fallback: /*#__PURE__*/ (0,jsx_runtime.jsx)(DashboardLayout/* DashboardLayout */.c, {
                loading: true
            }),
            children: (param)=>/*#__PURE__*/ {
                let { id  } = param;
                return (0,jsx_runtime.jsx)(PayoutsPage, {
                    userId: id
                });
            }
        })
    });
};
/* harmony default export */ var payouts = (Payouts);


/***/ }),

/***/ 21206:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "P": function() { return /* binding */ recursiveApplyTransformation; }
/* harmony export */ });
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(76635);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_0__);

const recursiveApplyTransformation = (/* eslint-disable @typescript-eslint/no-explicit-any */ value, transformation)=>{
    /* eslint-enable @typescript-eslint/no-explicit-any */ if (value == null) return value;
    if (value instanceof File) return value;
    if (typeof value === "string") {
        return transformation(value);
    }
    if (Array.isArray(value)) {
        return value.map((val)=>recursiveApplyTransformation(val, transformation));
    }
    if (typeof value === "object") {
        if (value instanceof Blob || value instanceof File) return value;
        if (value instanceof Date) return value;
        return (0,lodash__WEBPACK_IMPORTED_MODULE_0__.mapValues)(value, (val)=>recursiveApplyTransformation(val, transformation));
    }
    return value;
};


/***/ }),

/***/ 42526:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "h": function() { return /* binding */ useVetterDisclaimer; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);
/* harmony import */ var _vette_frontend_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(21335);
/* harmony import */ var _vette_frontend_utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7476);


const useVetterDisclaimer = ()=>{
    const { isVetter  } = _vette_frontend_utils__WEBPACK_IMPORTED_MODULE_1__/* .useRole */ .q();
    const showAwaitingNotification = (approvalPending)=>approvalPending && isVetter && _vette_frontend_utils__WEBPACK_IMPORTED_MODULE_2__/* .message.info */ .y.info("You are on the waitlist to become a Vetter. We will inform you once your account is approved.", 0);
    return (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)((param, initialMessage, duration)=>{
        let { approvalStatus , isProfileDataProvided  } = param;
        const approvalPending = !!isProfileDataProvided && approvalStatus !== "ACTIVE";
        _vette_frontend_utils__WEBPACK_IMPORTED_MODULE_2__/* .message.destroy */ .y.destroy();
        initialMessage ? _vette_frontend_utils__WEBPACK_IMPORTED_MODULE_2__/* .message.success */ .y.success({
            content: initialMessage,
            ...duration && {
                duration
            },
            onClose: ()=>showAwaitingNotification(approvalPending)
        }) : showAwaitingNotification(approvalPending);
    }, []);
};


/***/ }),

/***/ 87586:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "x": function() { return /* binding */ PageCard; }
});

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/@mui/icons-material/ArrowBack.js
var ArrowBack = __webpack_require__(28504);
// EXTERNAL MODULE: ../../libs/frontend-utils/src/next/ClientSide.tsx
var ClientSide = __webpack_require__(50110);
// EXTERNAL MODULE: ../../node_modules/antd/es/space/index.js + 1 modules
var space = __webpack_require__(94187);
// EXTERNAL MODULE: ../../node_modules/next/router.js
var next_router = __webpack_require__(5632);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../libs/ui-components/src/lib/common/atoms/Typography/styles.tsx
var styles = __webpack_require__(93430);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(92228);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 2 modules
var styled_components_browser_esm = __webpack_require__(58694);
// EXTERNAL MODULE: ../../libs/ui-components/src/lib/common/atoms/Button/index.tsx + 1 modules
var Button = __webpack_require__(81824);
// EXTERNAL MODULE: ../../node_modules/antd/es/layout/index.js + 9 modules
var layout = __webpack_require__(17332);
;// CONCATENATED MODULE: ../../libs/ui-components/src/lib/common/PageCard/styles.ts

function _templateObject() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex: 1;\n  flex-direction: column;\n  overflow-y: ",
        ";\n  height: ",
        ";\n\n  .ant-layout-header {\n    height: unset;\n  }\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  display: flex;\n  flex: 0 auto;\n  flex-direction: column;\n  padding: 48px 0px 72px;\n  border-radius: 18px;\n  background: ",
        ";\n  margin: 36px;\n  max-height: ",
        ";\n\n  @media print {\n    margin: 4px 0px;\n    padding: 0px;\n  }\n"
    ]);
    _templateObject1 = function() {
        return data;
    };
    return data;
}
function _templateObject2() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  justify-content: space-between;\n  position: sticky;\n  top: 0;\n  z-index: 888;\n  background: ",
        ";\n  padding: 12px 72px;\n  align-items: center;\n  border-bottom: 1px solid\n    ",
        ";\n"
    ]);
    _templateObject2 = function() {
        return data;
    };
    return data;
}
function _templateObject3() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  gap: 36px;\n"
    ]);
    _templateObject3 = function() {
        return data;
    };
    return data;
}
function _templateObject4() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex: 1;\n  justify-content: flex-end;\n  align-items: center;\n  gap: 8px;\n"
    ]);
    _templateObject4 = function() {
        return data;
    };
    return data;
}
function _templateObject5() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex: 1;\n  flex-direction: column;\n  padding: 48px 72px 0;\n  overflow-y: ",
        ";\n"
    ]);
    _templateObject5 = function() {
        return data;
    };
    return data;
}
function _templateObject6() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  @media print {\n    display: none;\n  }\n"
    ]);
    _templateObject6 = function() {
        return data;
    };
    return data;
}



const Layout = styled_components_browser_esm/* default.div */.ZP.div(_templateObject(), (param)=>{
    let { $allowScroll  } = param;
    return $allowScroll ? "" : "auto";
}, (param)=>{
    let { $allowScroll  } = param;
    return $allowScroll ? " calc(100vh - 72px)" : "";
});
const Card = styled_components_browser_esm/* default.div */.ZP.div(_templateObject1(), (param)=>{
    let { theme  } = param;
    return theme.colors.white;
}, (param)=>{
    let { $allowScroll  } = param;
    return $allowScroll ? "100%" : "";
});
const Header = (0,styled_components_browser_esm/* default */.ZP)(layout/* default.Header */.Z.Header)(_templateObject2(), (param)=>{
    let { theme  } = param;
    return theme.colors.white;
}, (param)=>{
    let { theme , $showBorder  } = param;
    return $showBorder ? theme.colors.grey20 : "transparent";
});
const HeaderSection = styled_components_browser_esm/* default.div */.ZP.div(_templateObject3());
const ActionsWrapper = styled_components_browser_esm/* default.div */.ZP.div(_templateObject4());
const Content = (0,styled_components_browser_esm/* default */.ZP)(layout/* default.Content */.Z.Content)(_templateObject5(), (param)=>{
    let { $allowScroll  } = param;
    return $allowScroll ? "auto" : "";
});
const BackButton = (0,styled_components_browser_esm/* default */.ZP)(Button/* Button */.z)(_templateObject6());

;// CONCATENATED MODULE: ../../libs/ui-components/src/lib/common/PageCard/index.tsx








const COLLAPSE_THRESHOLD = 84;
const COLLAPSE_THRESHOLD_RESERVE = 12;
const PageCard = /*#__PURE__*/ (0,react.forwardRef)((param, ref)=>{
    let { title , subtitle , hasBackButton , headerActions , children , footer , contentStyle , redirectBackRoute , allowScroll  } = param;
    const router = (0,next_router.useRouter)();
    const scrollRef = react.useRef(null);
    const [showCollapsedHeader, setShowCollapsedHeader] = react.useState(false);
    const handleScroll = (0,react.useCallback)(()=>{
        if (scrollRef.current) {
            const currentScrollY = scrollRef.current.scrollTop;
            // to avoid attaching multiple listeners to scrollRef
            // (react state cannot be used to track the changes here)
            const wentOverThreshold = scrollRef.current.classList.contains("over-threshold");
            if (currentScrollY > COLLAPSE_THRESHOLD && !wentOverThreshold) {
                setShowCollapsedHeader(true);
                scrollRef.current.classList.add("over-threshold");
            } else if (currentScrollY < COLLAPSE_THRESHOLD - COLLAPSE_THRESHOLD_RESERVE && wentOverThreshold) {
                setShowCollapsedHeader(false);
                scrollRef.current.classList.remove("over-threshold");
            }
        }
    }, []);
    (0,react.useEffect)(()=>{
        if (scrollRef.current) {
            scrollRef.current.addEventListener("scroll", handleScroll, {
                passive: true
            });
        }
    }, [
        handleScroll
    ]);
    (0,react.useImperativeHandle)(ref, ()=>({
            scrollToBottom: ()=>{
                if (scrollRef.current) scrollRef.current.scrollTop = scrollRef.current.scrollHeight;
            },
            scrollToTop: ()=>{
                if (scrollRef.current) scrollRef.current.scrollTop = 0;
            }
        }));
    const handleRedirectBack = ()=>{
        redirectBackRoute ? router.replace(redirectBackRoute) : router.back();
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ClientSide/* ClientSide */.B, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Layout, {
            ref: scrollRef,
            $allowScroll: allowScroll,
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Card, {
                $allowScroll: allowScroll,
                children: [
                    title && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Header, {
                        $showBorder: showCollapsedHeader,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(HeaderSection, {
                                children: [
                                    hasBackButton && /*#__PURE__*/ (0,jsx_runtime.jsx)(BackButton, {
                                        actionType: "secondary",
                                        size: "large",
                                        onClick: handleRedirectBack,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowBack/* default */.Z, {})
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(space/* default */.Z, {
                                        size: 0,
                                        direction: "vertical",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(styles/* Title */.Dx, {
                                                level: showCollapsedHeader ? 2 : 1,
                                                children: title
                                            }),
                                            subtitle && /*#__PURE__*/ (0,jsx_runtime.jsx)(styles/* Title */.Dx, {
                                                level: 3,
                                                children: subtitle
                                            })
                                        ]
                                    })
                                ]
                            }),
                            headerActions && /*#__PURE__*/ (0,jsx_runtime.jsx)(ActionsWrapper, {
                                children: headerActions
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Content, {
                        style: contentStyle,
                        $allowScroll: allowScroll,
                        children: children
                    }),
                    footer
                ]
            })
        })
    });
});


/***/ }),

/***/ 72131:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "l": function() { return /* binding */ Form; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var antd__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(86868);
/* harmony import */ var _vette_common_utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(21206);




// eslint-disable-next-line @typescript-eslint/no-explicit-any
const recursiveTrimValue = (value)=>_vette_common_utils__WEBPACK_IMPORTED_MODULE_2__/* .recursiveApplyTransformation */ .P(value, (val)=>val.trim());
const Form = (param)=>{
    let { onFinish , ...formProps } = param;
    const onFinishWrapper = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(// eslint-disable-next-line @typescript-eslint/no-explicit-any
    (value)=>{
        const trimmedValue = recursiveTrimValue(value);
        return onFinish === null || onFinish === void 0 ? void 0 : onFinish(trimmedValue);
    }, [
        onFinish
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(antd__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
        onFinish: onFinishWrapper,
        ...formProps
    });
};
Form.useForm = antd__WEBPACK_IMPORTED_MODULE_3__/* ["default"].useForm */ .Z.useForm;
Form.useFormInstance = antd__WEBPACK_IMPORTED_MODULE_3__/* ["default"].useFormInstance */ .Z.useFormInstance;
Form.useWatch = antd__WEBPACK_IMPORTED_MODULE_3__/* ["default"].useWatch */ .Z.useWatch;
Form.List = antd__WEBPACK_IMPORTED_MODULE_3__/* ["default"].List */ .Z.List;
Form.ErrorList = antd__WEBPACK_IMPORTED_MODULE_3__/* ["default"].ErrorList */ .Z.ErrorList;
Form.Item = antd__WEBPACK_IMPORTED_MODULE_3__/* ["default"].Item */ .Z.Item;
Form.Provider = antd__WEBPACK_IMPORTED_MODULE_3__/* ["default"].Provider */ .Z.Provider;
Form.create = antd__WEBPACK_IMPORTED_MODULE_3__/* ["default"].create */ .Z.create;


/***/ }),

/***/ 74606:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "x": function() { return /* binding */ FormItem_FormItem; }
});

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../libs/common-utils/src/helpers.ts
var helpers = __webpack_require__(21206);
// EXTERNAL MODULE: ../../node_modules/antd/es/grid/index.js
var grid = __webpack_require__(68358);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(92228);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 2 modules
var styled_components_browser_esm = __webpack_require__(58694);
;// CONCATENATED MODULE: ../../libs/ui-components/src/lib/common/atoms/FloatLabel/styles.ts

function _templateObject() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n\n  & .ant-input {\n    padding-top: 16px;\n    padding-bottom: 8px;\n  }\n\n  & .react-tel-input > .ant-input {\n    padding-top: 18px;\n    padding-bottom: 6px;\n    height: 50px;\n  }\n\n  & .label {\n    font-size: 15px;\n    font-weight: normal;\n    position: absolute;\n    pointer-events: none;\n    left: 12px;\n    top: 12px;\n    transition: 0.2s ease all;\n    color: ",
        ";\n  }\n\n  & .label-float {\n    top: 5px;\n    font-size: 10px;\n  }\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}

const MinimalInput = styled_components_browser_esm/* default.div */.ZP.div(_templateObject(), (param)=>{
    let { theme  } = param;
    return theme.colors.grey30;
});

;// CONCATENATED MODULE: ../../libs/ui-components/src/lib/common/atoms/FloatLabel/index.tsx



const FloatLabel = (param)=>{
    let { label , value , children  } = param;
    const [focus, setFocus] = (0,react.useState)(false);
    const labelClass = focus || value && (value === null || value === void 0 ? void 0 : value.length) !== 0 ? "label label-float" : "label";
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(MinimalInput, {
        className: "float-label",
        onBlur: ()=>setFocus(false),
        onFocus: ()=>setFocus(true),
        children: [
            children,
            /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                className: labelClass,
                children: label
            })
        ]
    });
};

// EXTERNAL MODULE: ../../libs/ui-components/src/lib/common/theme.ts
var theme = __webpack_require__(32657);
// EXTERNAL MODULE: ../../libs/ui-components/src/lib/common/atoms/Typography/styles.tsx
var styles = __webpack_require__(93430);
// EXTERNAL MODULE: ../../libs/ui-components/src/lib/common/atoms/Form/index.tsx
var Form = __webpack_require__(72131);
;// CONCATENATED MODULE: ../../libs/ui-components/src/lib/common/atoms/FormItem/styles.ts

function styles_templateObject() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n      &.ant-form-item-has-error .ant-form-item-label > label {\n        color: #ff4d4f;\n      }\n    "
    ]);
    styles_templateObject = function() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n      & .ant-form-item-label > label .ant-form-item-tooltip {\n        background: ",
        ";\n        color: ",
        ";\n        border-radius: 50%;\n      }\n    "
    ]);
    _templateObject1 = function() {
        return data;
    };
    return data;
}
function _templateObject2() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: inline;\n\n  font-size: 12px;\n  font-weight: 600;\n  line-height: 1;\n  margin-bottom: 0;\n\n  ",
        "\n  &\n    .ant-form-item-label {\n    padding-bottom: 0;\n    white-space: unset;\n    text-align: left;\n    line-height: 1.6;\n\n    > label {\n      height: fit-content;\n      margin-top: 5px;\n      margin-bottom: 5px;\n    }\n\n    > label::after {\n      display: none;\n    }\n  }\n\n  &\n    .ant-form-item-label\n    > label.ant-form-item-required:not(\n      .ant-form-item-required-mark-optional\n    )::before {\n    display: none;\n  }\n\n  & .ant-form-item-control {\n    width: 100%;\n  }\n\n  .ant-form-item-with-help .ant-form-item-explain {\n    min-height: 0px;\n  }\n\n  .ant-form-item-explain-error {\n    font-size: 10px;\n  }\n\n  &.ant-form-item-has-error .ant-input {\n    border-color: #ff4d4f;\n    box-shadow: ",
        ";\n  }\n\n  ",
        "\n\n  .ant-input-status-error {\n    box-shadow: ",
        ";\n  }\n\n  .ant-select-status-error > .ant-select-selector {\n    box-shadow: ",
        ";\n  }\n"
    ]);
    _templateObject2 = function() {
        return data;
    };
    return data;
}
function _templateObject3() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-top: -15px;\n"
    ]);
    _templateObject3 = function() {
        return data;
    };
    return data;
}
function _templateObject4() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding-left: 20px;\n  max-height: 50px;\n  overflow-y: scroll;\n"
    ]);
    _templateObject4 = function() {
        return data;
    };
    return data;
}
function _templateObject5() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 10px;\n  font-weight: 600;\n  color: ",
        ";\n"
    ]);
    _templateObject5 = function() {
        return data;
    };
    return data;
}


const { Item  } = Form/* Form */.l;
const FormItem = (0,styled_components_browser_esm/* default */.ZP)(Item)(_templateObject2(), (param)=>{
    let { $redLabelOnError  } = param;
    return $redLabelOnError && (0,styled_components_browser_esm/* css */.iv)(styles_templateObject());
}, (param)=>{
    let { theme  } = param;
    return "inset 0 0 0 500px ".concat(theme.colors.red20);
}, (param)=>{
    let { $hasToolTip  } = param;
    return $hasToolTip && (0,styled_components_browser_esm/* css */.iv)(_templateObject1(), (param)=>{
        let { theme  } = param;
        return theme.colors.grey60;
    }, (param)=>{
        let { theme  } = param;
        return theme.colors.white;
    });
}, (param)=>{
    let { theme  } = param;
    return "inset 0 0 0 500px ".concat(theme.colors.red20);
}, (param)=>{
    let { theme  } = param;
    return "inset 0 0 0 500px ".concat(theme.colors.red20);
});
const CustomErrorDisplay = styled_components_browser_esm/* default.div */.ZP.div(_templateObject3());
const List = styled_components_browser_esm/* default.ul */.ZP.ul(_templateObject4());
const ListItem = styled_components_browser_esm/* default.li */.ZP.li(_templateObject5(), (param)=>{
    let { theme  } = param;
    return theme.colors.red60;
});

;// CONCATENATED MODULE: ../../libs/ui-components/src/lib/common/atoms/FormItem/index.tsx








// eslint-disable-next-line @typescript-eslint/no-explicit-any
const recursiveTrimStartValue = (value)=>{
    return helpers/* recursiveApplyTransformation */.P(value, (val)=>val.trimStart());
};
const FormItem_FormItem = (param)=>{
    let { ignoreNormalize , compact , customError , redLabelOnError =false , ...formItemProps } = param;
    const { xs  } = grid/* default.useBreakpoint */.ZP.useBreakpoint();
    const [currentValue, setCurrentValue] = (0,react.useState)(formItemProps.initialValue);
    const customErrorBox = customError ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(CustomErrorDisplay, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(styles/* Text */.xv, {
                $size: 9,
                $weight: 600,
                $color: theme/* theme.colors.red60 */.r.colors.red60,
                children: customError.title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(List, {
                children: customError.errors.map((e, index)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(ListItem, {
                        children: e
                    }, index))
            })
        ]
    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
    if (compact && xs) {
        const { label , ...restFormItemProps } = formItemProps;
        const normalize = (value)=>{
            const finalValue = !ignoreNormalize ? recursiveTrimStartValue(value) : value;
            setCurrentValue(finalValue);
            return finalValue;
        };
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(FloatLabel, {
            label: formItemProps.label,
            value: currentValue,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(FormItem, {
                    $redLabelOnError: redLabelOnError,
                    normalize: normalize,
                    ...restFormItemProps
                }),
                customErrorBox
            ]
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(FormItem, {
                $redLabelOnError: redLabelOnError,
                normalize: !ignoreNormalize ? recursiveTrimStartValue : undefined,
                ...formItemProps,
                $hasToolTip: !!formItemProps.tooltip
            }),
            customErrorBox
        ]
    });
};


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [746,868,72,747,774,888,179], function() { return __webpack_exec__(42967); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);